import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';

import store from '../store/configure';
import select from '../utils/select';
import Video, { IVideoProps } from './Video';
import { SELECTOR } from './constants';

export default function buildVideo({
  externalId,
  selectorSuffix,
  type,
  caption,
  credit,
  display,
}: {
  externalId: IVideoProps['externalId'];
  selectorSuffix: string;
  type: IVideoProps['type'];
  caption?: IVideoProps['caption'];
  credit?: IVideoProps['credit'];
  display?: IVideoProps['display'];
}): void {
  const attachEl = select(`#${SELECTOR}-${selectorSuffix}`);

  render(
    <Provider store={store}>
      <Video
        externalId={externalId}
        type={type}
        caption={caption}
        credit={credit}
        display={display}
      />
    </Provider>,
    attachEl
  );
}
